import { Builder } from '@builder.io/react'
import { faCheck, faChevronRight, faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Cache } from 'aws-amplify'
import RecipeOrTreatAlterModal from 'components/ui/modal/RecipeOrTreatModalAlter'
import CdnImage from 'components/util/CdnImage'
import { getCognitoId, getVisitorId } from 'components/util/UserId'
import dayjs from 'dayjs'
import { Field, Formik } from 'formik'
import { StaticImage } from 'gatsby-plugin-image'
import { parse } from 'query-string'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'state'
import {
  createDogs,
  preserveDogNamesOnReset,
  updateCouponCodeValidity,
  updateCurrCouponCode
} from 'state/actions/dogAction'
import { updateCouponHash, updatePlanHash } from 'state/actions/hashAction'
import { resetKey, updateKey } from 'state/actions/keyAction'
import { resetParent } from 'state/actions/parentAction'
import { addAddons, addRecipes, postPlanId, resetPlan } from 'state/actions/planAction'
import { getProducts } from 'state/actions/productsAction'
import { resetShipping } from 'state/actions/shippingAction'
import { DogType } from 'state/types/dogType'
import { RecipesSchema } from 'utils/yup-validation-schema'
import CheckCircle from '../../../images/builder/checkCircle.svg'
import Pack from '../../../images/builder/icons/DDFoodPot.svg'
import Discount from '../../../images/builder/icons/Discount.svg'
import Calendar from '../../../images/builder/icons/Plan.svg'
import Sample from '../../../images/builder/icons/Sample.svg'
import Treat from '../../../images/builder/icons/Treats.svg'
import Vet from '../../../images/builder/icons/Vet.svg'
import Api from '../../../state/apis/api'
import './index.css'
import { API } from 'aws-amplify'
import { triggerTagging } from 'components/util/common-utils'
import { getPersonalisedDataForAPI } from 'utils/personalise'

enum Alignment {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

interface AddonIds {
  id: string
}

interface SelectedPack {
  heading?: string
  subHeading?: string
  default: boolean
  name: string
  description?: string
  planImage?: any
  planImageAlt?: string
  ongoing: {
    quantity: number
    size: 250 | 600 | 1000
    weeks: 2 | 4 | 8
    price?: number
    pricePerDay?: number
  }
  trial?: {
    quantity?: number
    size?: 250 | 600 | 1000
    weeks?: 2 | 4 | 8
    price?: number
    pricePerDay?: number
  }
  displayPackInformation: boolean
  displayCalculatedPrice: boolean
  showPricePerDay: boolean
  showOriginalPriceStrikethrough: boolean
  coupon: string
  defaultOffer: boolean
  flexibleQuantity: boolean
  preSelectRecipes: boolean
  renderInfoSection: boolean
  freeTreatId?: string
  showFreeTreatOptions: boolean
}

interface Props {
  turboRouteConfiguration: any
  backgroundColor: string
  mainHeading: string
  mainHeadingColor: string
  mainSubheading?: string
  textAlignment: Alignment
  topBanner: any
  topBannerMobile: any
  topImage: any
  topImageMobile: any
  topImageAlt: string
  footerImage: any
  footerImageMobile: any
  removeWidget: boolean
  showTrustpilotImage: boolean
  widgetType: WidgetType
  widgetTags: string
  widgetColor: string
  showFreeSample: boolean
  freeTreatOptionIds: AddonIds[]
  freeTreatHeading: string
  freeTreatSubHeading: string
  simpleRecipeCards: boolean
  recipeCardsShow: boolean
  recipesWithMostPopularBanner: any
  showHealthRecipeCard: boolean
  showEndRecipeCard: boolean
  showTreatCardButton: boolean
}

const TurboRoute = ({
  turboRouteConfiguration,
  backgroundColor,
  mainHeading,
  mainHeadingColor,
  mainSubheading,
  textAlignment,
  topBanner,
  topBannerMobile,
  topImage,
  topImageMobile,
  topImageAlt,
  footerImage,
  footerImageMobile,
  removeWidget = false,
  showTrustpilotImage = false,
  widgetType,
  widgetTags,
  widgetColor,
  showFreeSample,
  freeTreatOptionIds,
  freeTreatHeading,
  freeTreatSubHeading,
  simpleRecipeCards = false,
  recipeCardsShow,
  recipesWithMostPopularBanner,
  showHealthRecipeCard,
  showEndRecipeCard,
  showTreatCardButton
}: Props) => {
  const {
    dogInfo,
    coupon,
    isValidCoupon,
    lastValidatedCoupon,
    lastValidatedCoupons,
    packNew
  }: {
    dogInfo: DogType
    coupon: any
    isValidCoupon: boolean
    lastValidatedCoupon: CouponType
    lastValidatedCoupons: CouponsType[]
    packNew: PackNewType
  } = useSelector((state: RootState) => state.dog)

  const { couponHash, planHash } = useSelector((state: RootState) => state.hash)
  let { recipeList, addonList }: { recipeList: RecipeAddonType[]; addonList?: RecipeAddonType[] } = useSelector(
    (state: RootState) => state.products
  )

  const [modalShow, setModalShow] = useState(false)
  const [modalActiveRecipe, setModalActiveRecipe] = useState({})
  const [showStickyFooter, setShowStickyFooter] = useState(true)

  const [recipeCount, setRecipeCount] = useState(0)
  const [recipes, setRecipes] = useState<Array<{ id: string; quantity: number }>>([])

  const [dogNames, setDogNames] = useState([''])
  const [errors, setErrors] = useState<string[]>([])
  const [packSize, setPackSize] = useState(0)
  const [selectedPack, setSelectedPack] = useState<SelectedPack | null>(null)
  const [selectedTreatId, setSelectedTreatId] = useState<string | null>(null)

  const [showRecipes, setShowRecipes] = useState(false)
  const [showMinQuantityErrorMessage, setShowMinQuantityErrorMessage] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  // For the price
  const [deliveryDate, setDeliveryDate] = useState()
  const [pricePerDay, setPricePerDay] = useState<number | undefined>(undefined)

  // Used to update the plan
  const [storeRecipeIds, setStoreRecipeIds] = useState<Array<{ itemId: any; price: number }>>([])
  const [storeAddonIds, setStoreAddonIds] = useState<Array<{ itemId: any; price: number }>>([])
  const [freeTreatList, setFreeTreatList] = useState<RecipeAddonType[]>([])

  const [cognitoId, setCognitoId] = useState('')
  const [visitorId, setVisitorId] = useState('')

  const dispatch = useDispatch()

  const popularRecipeIds = recipesWithMostPopularBanner?.map((item: any) => item.itemId)

  const isValidFreeTreat =
    turboRouteConfiguration.freeTreatId &&
    addonList?.some(addon => addon.itemId === turboRouteConfiguration.freeTreatId)

  // Free treat to be added to plan
  // Use free treat prop, or fallback
  const freeTreat = isValidFreeTreat
    ? [{ id: turboRouteConfiguration.freeTreatId, quantity: 1 }]
    : [{ id: 'TRET-TUSN', quantity: 1 }]

  // Default options
  const packOptions = [
    { value: 250, minQuantity: 12, maxQuantity: 55 },
    { value: 600, minQuantity: 7, maxQuantity: 41 },
    { value: 1000, minQuantity: 5, maxQuantity: 41 }
  ]

  // const weeksToDays = {
  //   2: 14,
  //   4: 28,
  //   8: 56
  // }
  // Not ideal to hardcode these in FE,
  // and another object to maintain
  // TODO:fix this?
  // const packPrice = {
  // 250: 340,
  // 600: 690,
  // 1000: 930
  // }

  const currentPackOptionDefaults = packOptions.find(option => option.value === packSize) || {}

  const maxRecipeLimit =
    (!turboRouteConfiguration.flexibleQuantity &&
      selectedPack &&
      ((selectedPack.trial?.quantity != null && recipeCount >= selectedPack.trial.quantity) ||
        (selectedPack.trial?.quantity == null && recipeCount >= selectedPack.ongoing?.quantity))) ||
    (turboRouteConfiguration.flexibleQuantity && recipeCount >= currentPackOptionDefaults?.maxQuantity)

  useEffect(() => {
    dispatch(getProducts())
    // Reset the store for clean run through turbo route
    dispatch(preserveDogNamesOnReset())
    dispatch(resetKey())
    dispatch(resetParent())
    dispatch(resetPlan())
    dispatch(resetShipping())

    const callCognitoVisitorId = async () => {
      setCognitoId(await getCognitoId())
      setVisitorId(await getVisitorId())
    }
    callCognitoVisitorId()
  }, [])

  useEffect(() => {
    // Add turbo route to pathname on gtag pageview events
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'page_view', {
        page: window.location.pathname + '/turbo-route'
      })
    }
  }, [])

  useEffect(() => {
    // Removes the click to view recipes, recipes auto show
    if (recipeCardsShow) {
      setShowRecipes(true)
    }
  }, [recipeCardsShow])

  useEffect(() => {
    // Add turbo route pageview event
    const sendPageviewEvent = async () => {
      if (window?.location?.pathname) {
        if (visitorId) {
          await API.post('wwwREST', '/v1/public/event', {
            body: {
              path: window?.location?.pathname + '/turbo-route',
              visitorId,
              name: 'pageview',
              personalise: getPersonalisedDataForAPI()
            }
          }).catch((err: any) => {
            console.error(JSON.stringify(err, null, 2))
          })
        }
      }
    }
    sendPageviewEvent()
  }, [visitorId])

  useEffect(() => {
    // Hash checks
    if (packNew && packNew.hash && packNew.hash !== planHash) {
      dispatch(updatePlanHash(packNew.hash))
    }

    if (coupon && coupon.hash && coupon.hash !== couponHash) {
      dispatch(updateCouponHash(coupon.hash))
    }
  }, [coupon, couponHash, packNew, planHash])

  useEffect(() => {
    if (dogInfo.dogs && dogInfo.dogs.length > 0) {
      const storedDogNames = dogInfo.dogs.map(dog => dog.name?.trim()).filter(name => name)
      if (storedDogNames.length > 0) {
        setDogNames(storedDogNames)
      }
    }
  }, [dogInfo.dogs])

  useEffect(() => {
    // Priorise the QS sign up flow coupon and update store
    if (!turboRouteConfiguration.defaultOffer) {
      const { coupon: couponFromQueryStr } = parse(location.search)
      let coupon = couponFromQueryStr ?? Cache.getItem('coupon') ?? null
      if (coupon) {
        coupon = coupon.toUpperCase()
        dispatch(updateCouponCodeValidity('checkValidity', coupon as string))
      } else {
        dispatch(updateCouponCodeValidity('checkValidity', turboRouteConfiguration.coupon as string))
      }
    }
  }, [])

  // Handle coupons from the URL querystring
  useEffect(() => {
    // Priorise the QS sign up flow coupon, then look for a content page coupon, otherwise we fallback to the default
    if (!turboRouteConfiguration.defaultOffer) {
      const { coupon: couponFromQueryStr } = parse(location.search)
      let coupon = couponFromQueryStr ?? Cache.getItem('coupon') ?? null
      if (coupon) {
        coupon = coupon.toUpperCase()
        dispatch(updateCouponCodeValidity('checkValidity', coupon as string))
      }
      if (turboRouteConfiguration.coupon) {
        // Update coupon to turbo route coupon
        dispatch(updateCurrCouponCode(turboRouteConfiguration.coupon as string))
        Cache.setItem('coupon', turboRouteConfiguration.coupon)
      }
    }
  }, [])

  useEffect(() => {
    // Gets delivery date for estimate api
    if (turboRouteConfiguration.displayCalculatedPrice) {
      Api.get('wwwREST', '/v1/public/signup/calendar', {})
        .then(({ shippingDates }) => {
          const defaultDate = shippingDates.find((d: any) => d.price === 0).date
          setDeliveryDate(defaultDate)
        })
        .catch((err: any) => {
          console.error(JSON.stringify(err, null, 2))
        })
    }
  }, [])

  useEffect(() => {
    // Pre select pack option
    if (turboRouteConfiguration?.plans?.length) {
      const plans = turboRouteConfiguration.plans
      // // To pre select middle pack option
      // const middleIndex = Math.floor((plans.length - 1) / 2)
      // setSelectedPack(plans[middleIndex])
      // setPackSize(parseInt(plans[middleIndex].ongoing.size))
      // To pre select first pack option
      setSelectedPack(plans[0])
      setPackSize(parseInt(plans[0].ongoing.size))
    }
  }, [])

  useEffect(() => {
    // If plan selected, populate state and store
    if (packSize > 0) {
      updateDogStore(dogNames)
      updatePlanStore()
    }
  }, [packSize])

  useEffect(() => {
    //  Populate the state with the recipes and addons used update the plan
    if (packNew?.default === 'fullTrial' || packNew?.default === 'full') {
      const fullPlan = packNew.plans.find((plan: any) => plan.size === 'full')
      setStoreRecipeIds(fullPlan?.main.recipes?.length ? fullPlan.main.recipes : fullPlan?.trial.recipes)
      setStoreAddonIds(fullPlan?.main.addons?.length ? fullPlan.main.addons : fullPlan?.trial.addons)
    }
    if (packNew?.default === 'partialTrial' || packNew?.default === 'partial') {
      const partialPlan = packNew.plans.find((plan: any) => plan.size === 'partial')
      setStoreRecipeIds(partialPlan?.main.recipes?.length ? partialPlan.main.recipes : partialPlan?.trial.recipes)
      setStoreAddonIds(partialPlan?.main.addons?.length ? partialPlan.main.addons : partialPlan?.trial.addons)
    }
  }, [packNew])

  useEffect(() => {
    // Pre selected pack
    if (
      turboRouteConfiguration.preSelectRecipes &&
      packSize > 0 &&
      (selectedPack?.trial?.quantity || selectedPack?.ongoing?.quantity) &&
      recipeList.length > 0
    ) {
      setRecipeCount(0)
      setRecipes([])
      const standardRecipes = recipeList.filter(
        recipe =>
          recipe.range !== 'health' &&
          recipe.status !== 'OUTOFSTOCK' &&
          recipe.itemId !== 'RECP-PORA' && // Filter out Pork Ragu
          recipe.itemId !== 'RECP-VETH' // Filter out Venison and Thyme
      )
      const recipesToAdd: { id: string; quantity: number }[] = []

      const quantityToPreSelect = selectedPack?.trial?.quantity || selectedPack?.ongoing?.quantity

      for (let i = 0; i < quantityToPreSelect; i++) {
        const recipe = standardRecipes[i % standardRecipes.length]

        const existingRecipeIndex = recipesToAdd.findIndex(r => r.id === recipe.itemId)
        if (existingRecipeIndex !== -1) {
          recipesToAdd[existingRecipeIndex].quantity += 1
        } else {
          recipesToAdd.push({ id: recipe.itemId, quantity: 1 })
        }
      }

      setRecipes(prevRecipes => {
        const updatedRecipes = [...prevRecipes]
        // Integrate new recipes into existing ones
        recipesToAdd.forEach(newRecipe => {
          const index = updatedRecipes.findIndex(r => r.id === newRecipe.id)
          if (index !== -1) {
            updatedRecipes[index].quantity += newRecipe.quantity
          } else {
            updatedRecipes.push(newRecipe)
          }
        })
        return updatedRecipes
      })

      setRecipeCount(curr => curr + quantityToPreSelect)
    }
  }, [selectedPack, recipeList])

  useEffect(() => {
    // Gets the details of the free treat options
    if (!addonList || !freeTreatOptionIds) return

    const idList = freeTreatOptionIds.map(item => item.id)
    const filtered = idList
      .map(id => addonList.find(addon => addon.itemId === id))
      .filter((addon): addon is RecipeAddonType => !!addon && addon.status !== 'OUTOFSTOCK')
    if (filtered.length > 0) {
      setFreeTreatList(filtered)
      // Pre select first treat option
      setSelectedTreatId(filtered[0].itemId)
    }
  }, [addonList, freeTreatOptionIds])

  useEffect(() => {
    // Min quantity error message remove
    if (recipeCount === selectedPack?.trial?.quantity) {
      setShowMinQuantityErrorMessage(false)
    }
    if (recipeCount === selectedPack?.ongoing?.quantity) {
      setShowMinQuantityErrorMessage(false)
    }
  }, [recipeCount, selectedPack])

  useEffect(() => {
    // Get price per day, either calculated through estimate, hardcoded from builder or calculated from selected pack size, quantity and weeks
    const totalRecipeQuantity = recipes.reduce((sum, recipe) => sum + recipe.quantity, 0)
    if (selectedPack?.trial?.pricePerDay) {
      setPricePerDay(Number((selectedPack?.trial?.pricePerDay / 100).toFixed(2)))
    }
    // Ensure all required fields exist and recipes correctly populated
    if (
      !selectedPack?.ongoing?.size ||
      !selectedPack?.ongoing?.weeks ||
      totalRecipeQuantity !== selectedPack.ongoing.quantity
    ) {
      return
    }

    // Gets the price per day value for the info box from the estimate api
    // if (turboRouteConfiguration.displayCalculatedPrice) {
    //   setPricePerDay(undefined)

    //   if (!recipes || recipes.length === 0) {
    //     return
    //   }

    //   const planObj = {
    //     id: `${selectedPack?.ongoing?.size}g-${selectedPack?.ongoing?.weeks}w`,
    //     type: 'CUSTOM',
    //     grams: Number(selectedPack?.ongoing?.size)
    //   }

    //   // Call estimates API to get price per day
    //   if (totalRecipeQuantity === recipeCount && deliveryDate) {
    //     const url = '/v1/public/signup/estimate'

    //     Api.post('wwwREST', url, {
    //       body: {
    //         coupon: lastValidatedCoupon.code || '',
    //         recipes: recipes,
    //         addons: [],
    //         plan: planObj,
    //         deliveryDate: dayjs(deliveryDate).format('YYYY-MM-DD'),
    //         visitorId: dogInfo.visitorId
    //       }
    //     })
    //       .then(async ({ current }) => {
    //         const pricePerDayWithDiscount =
    //           coupon.type === 'percentage'
    //             ? Number(((current.costPerDay * (1 - coupon.amount / 100)) / 100).toFixed(2))
    //             : Number((current.costPerDay / 100).toFixed(2))

    //         setPricePerDay(pricePerDayWithDiscount)
    //       })
    //       .catch(async (err: any) => {
    //         console.error(JSON.stringify(err, null, 2))
    //       })
    //   }
    // } else
    if (selectedPack?.ongoing?.pricePerDay) {
      // Gets the hardcoded price per day from the selected pack
      setPricePerDay(Number((selectedPack?.ongoing?.pricePerDay / 100).toFixed(2)))
      // } else {
      //   // Calculates price per day on selected pack values
      //   const selectedPackPrice = packPrice[selectedPack?.ongoing?.size]
      //   const selectedDays = weeksToDays[selectedPack?.ongoing?.weeks]

      //   setPricePerDay(Number(((selectedPackPrice * selectedPack?.ongoing?.quantity) / selectedDays / 100).toFixed(2)))
    }
  }, [selectedPack, recipes, recipeCount, deliveryDate, coupon])

  useEffect(() => {
    const trustWidget = document.getElementById('trust-pilot-micro-combo')
    window.Trustpilot?.loadFromElement(trustWidget)
  }, [widgetType])

  const handleAddDog = () => {
    if (dogNames.some(name => name.trim() === '')) {
      setErrors(dogNames.map(name => (name.trim() === '' ? "Please enter your dog's name." : '')))
      return
    }
    setDogNames([...dogNames, ''])
    setErrors([...errors, ''])
  }

  const getDiscountedPrice = (price: number) => {
    let total = price

    if (price > 0 && lastValidatedCoupon?.code) {
      if (lastValidatedCoupon.type === 'percentage') {
        total = price - (lastValidatedCoupon.amount / 100) * price
      } else if (lastValidatedCoupon.type === 'amount') {
        total = price - lastValidatedCoupon.amount / 100
      }
    }
    return total
  }

  const handleDogNameChange = (index: number, value: any) => {
    const updatedDogs = [...dogNames]
    updatedDogs[index] = value
    setDogNames(updatedDogs)

    const updatedErrors = [...errors]
    updatedErrors[index] = value.trim() === '' ? "Please enter your dog's name." : ''
    setErrors(updatedErrors)
    setShowStickyFooter(false)
  }

  const updatePlanStore = async () => {
    try {
      if (!storeRecipeIds?.length || !storeAddonIds?.length) {
        console.error('Missing recipes and addons to update the plan store')
        return false
      }

      let planId = `${packSize}g-${selectedPack?.trial?.weeks || selectedPack?.ongoing?.weeks}w`
      let planObject = {
        planId,
        packSize,
        numberOfPacks: recipeCount,
        weeks: selectedPack?.trial?.weeks || selectedPack?.ongoing?.weeks,
        recipes: storeRecipeIds,
        addons: storeAddonIds
      }

      await dispatch(
        postPlanId({
          planId,
          planObject,
          noOfPacks: recipeCount,
          customOngoingNoOfPacks: selectedPack?.ongoing?.quantity,
          packSize,
          weeks: selectedPack?.trial?.weeks || selectedPack?.ongoing?.weeks,
          isDefaultPlan: false,
          packType: selectedPack?.trial?.quantity ? 'CUSTOM_TRIAL' : 'CUSTOM',
          fixedOrCustomPlan: 'CUSTOM'
          // packType: selectedPack?.trial?.quantity ? 'PARTIAL_TRIAL' : 'CUSTOM',
          // fixedOrCustomPlan: selectedPack?.trial?.quantity ? 'FIXED' : 'CUSTOM'
        })
      )

      await dispatch(addRecipes(recipes, true))
      if (turboRouteConfiguration.showFreeTreatOptions && selectedTreatId) {
        await dispatch(addAddons([{ id: selectedTreatId, quantity: 1 }]))
      } else {
        await dispatch(addAddons(freeTreat))
      }
      return true
    } catch (error) {
      console.error('Error in updatePlanStore:', error)
      return false
    }
  }

  const handleMinQuantityError = () => {
    setShowMinQuantityErrorMessage(true)
    const recipeError = document.getElementById('minQuantityRecipeError')
    if (recipeError) {
      setShowRecipes(true)
      recipeError.scrollIntoView({ behavior: 'smooth', block: 'center' })
      recipeError.focus()
    }
    setIsSubmitting(false)
    return
  }

  const handleSubmitToCheckout = async () => {
    setIsSubmitting(true)
    if (!dogNames.length || dogNames.every(name => name.trim() === '')) {
      setErrors(dogNames.map(name => (name.trim() === '' ? "Please enter your dog's name." : '')))
      // Scroll to dog name field
      const dogNameField = document.getElementById('dogNameField')
      if (dogNameField) {
        dogNameField.scrollIntoView({ behavior: 'smooth', block: 'center' })
        dogNameField.focus()
      }
      setIsSubmitting(false)
      return
    }
    if (selectedPack && selectedPack?.trial?.quantity && recipeCount < selectedPack?.trial?.quantity) {
      handleMinQuantityError()
      return
    }
    if (selectedPack && !selectedPack?.trial?.quantity && recipeCount < selectedPack?.ongoing?.quantity) {
      handleMinQuantityError()
      return
    }
    if (cognitoId && cognitoId.trim() !== '') {
      // Redirect to account if logged in
      window.location.href = `/account`
      setIsSubmitting(false)
    } else {
      const updateDogs = await updateDogStore(dogNames)
      const updatePlan = await updatePlanStore()
      if (updateDogs && updatePlan) {
        dispatch(updateCurrCouponCode(lastValidatedCoupon.code as string))
        triggerTagging('turbo_route_checkout_submit', 'turbo_route')
        // Turbo need capitalising to match the key types
        dispatch(updateKey('checkout', null, location?.pathname, 'turbo'))
        // Stop the scroll to the top of page on submit
        history.replaceState({ scrollY: window.scrollY }, '')
        window.location.href = `/signup/checkout`
      }
      setIsSubmitting(false)
    }
  }

  const updateDogStore = async (updatedDogs: any) => {
    const dogData = {
      weight: 0,
      dob: '',
      exercise: '',
      physique: '',
      breed: '',
      neutered: '',
      gender: '',
      medicalConditionOrAllergies: '',
      fussy: '',
      unknownBreed: ''
    }
    await dispatch(
      createDogs({
        customer: dogInfo.customer,
        dogs: updatedDogs.map(name => ({ ...dogData, name })),
        visitorId
      })
    )
    return true
  }

  const getAlignmentClass = () => {
    if (textAlignment === Alignment.Right) {
      return 'text-right'
    }
    if (textAlignment === Alignment.Center) {
      return 'text-center'
    }
    return 'text-left'
  }

  const getRecipeQuantity = (recipeId: string) => {
    if (recipes) {
      const index = recipes.findIndex(recipe => recipe.id === recipeId)
      if (index !== -1) {
        return recipes[index].quantity
      }
    }
    return 0
  }

  const getRecipePrice = (recipe: string) => {
    if (storeRecipeIds) {
      const price = storeRecipeIds?.filter((r: any) => r.itemId === recipe)
      if (price?.length) return price[0].price / 100
    }
  }

  const handleAddRecipe = (recipeId: string) => {
    let recipesFormData: any = []
    if (recipes) {
      const index = recipes.findIndex(recipe => recipe.id === recipeId)
      if (index !== -1) {
        const recipesArr = [...recipes]
        recipesArr[index].quantity = recipesArr[index].quantity + 1
        recipesFormData = [...recipesArr]
        setRecipes(recipesFormData)
      } else {
        recipesFormData = [...recipes, { id: recipeId, quantity: 1 }]
        setRecipes(recipesFormData)
      }
    } else {
      recipesFormData = [{ id: recipeId, quantity: 1 }]
      setRecipes(recipesFormData)
    }

    setRecipeCount(curr => curr + 1)
  }

  const handleRemoveRecipe = (recipeId: string) => {
    let recipesFormData: any = []
    if (recipes) {
      const index = recipes.findIndex(recipe => recipe.id === recipeId)

      if (index !== -1) {
        if (recipes[index].quantity > 1) {
          const recipesArr = [...recipes]
          recipesArr[index].quantity = recipesArr[index].quantity - 1
          recipesFormData = [...recipesArr]
          setRecipes(recipesFormData)
        } else {
          recipesFormData = recipes.filter(recipe => recipe.id !== recipeId)
          setRecipes(recipesFormData)
        }
        setRecipeCount(curr => curr - 1)
      }
    }
  }

  const getWidget = () => {
    return (
      <div>
        {/* <!-- TrustBox widget - Micro Combo --> */}
        <div
          className={`trustpilot-widget trustpilot-widget-black `}
          data-locale="en-GB"
          data-template-id="5419b6ffb0d04a076446a9af"
          data-businessunit-id="5af423d4a3303b0001bf47c1"
          data-style-height="14px"
          data-style-width="100%"
          // data-theme="light"
          data-stars="5"
          data-font-family="Montserrat"
          data-text-color={widgetColor ? widgetColor : ''}
          data-tags={widgetTags ? widgetTags : ''}
          id="trust-pilot-micro-combo"
        >
          <a href="https://uk.trustpilot.com/review/differentdog.com" target="_blank" rel="noreferrer noopener">
            <StaticImage
              objectFit="contain"
              className="w-full"
              src="../../../images/trustpilot-single-line.png"
              alt="Trustpilot"
            />
          </a>
        </div>
        {/* <!-- End TrustBox widget --> */}
      </div>
    )
  }

  const renderText = () => {
    return (
      <div className={`text-center lg:${getAlignmentClass()} pb-2 lg:pb-4 lg:mt-6 2xl:mt-10`}>
        <span className="text-2xl lg:text-4xl font-medium font-sans" style={{ color: mainHeadingColor }}>
          {mainHeading}
        </span>
        <br />

        {mainSubheading && <div className="" dangerouslySetInnerHTML={{ __html: mainSubheading }} />}
      </div>
    )
  }

  const renderDogNameField = () => {
    return (
      <div
        id="turboRoute"
        className="relative flex flex-col w-5/6 md:w-full flex-shrink-0 items-center justify-center mx-auto pb-4"
      >
        {dogNames.map((dogName: string, index: number) => (
          <label key={index} className="mx-auto mb-2 flex w-full flex-col">
            <div className="relative w-full lg:w-auto max-w-[52rem] mx-auto">
              <input
                id="dogNameField"
                type="text"
                value={dogName}
                className="text-base block w-full lg:w-[30rem] rounded-full border-2 border-gray-200 bg-white py-4 pr-12 pl-6 text-center focus:border-highlight focus:ring-highlight placeholder-[#006685]"
                placeholder={`What's your dog's name`}
                onChange={e => handleDogNameChange(index, e.target.value)}
                onBlur={async e => {
                  let names = e.target.value
                    .split(',')
                    .map(name => name.trim())
                    .filter(Boolean)
                  names = names.map(name => name.charAt(0).toUpperCase() + name.slice(1))

                  if (names.length === 0) return

                  const updatedDogs = [...dogNames]
                  updatedDogs.splice(index, 1, ...names)
                  setDogNames(updatedDogs.slice(0, 5)) // Max 5 dogs
                  updateDogStore(updatedDogs)

                  names.forEach(name => triggerTagging('turbo_route_dog_name_entered', 'turbo_route', name))
                }}
              />

              {index > 0 && ( // Remove button for 2nd dog onwards
                <FontAwesomeIcon
                  className="absolute right-6 top-1/2 -translate-y-1/2 cursor-pointer text-gray-500 hover:text-red-500"
                  onClick={() => {
                    const updatedDogs = dogNames.filter((_, i) => i !== index)
                    setDogNames(updatedDogs)
                    updateDogStore(updatedDogs)
                  }}
                  icon={faXmark}
                  fontSize={18}
                />
              )}
            </div>

            {errors[index] && <div className="text-center text-xs text-red-500">{errors[index]}</div>}
          </label>
        ))}
        <div className="mb-2 flex justify-center p-2">
          {dogNames.length < 5 && !dogNames.every(name => name.trim() === '') && (
            <button className="font-sans mb-0 w-full self-center text-sm" onClick={handleAddDog}>
              <StaticImage
                src={'../../../../images/dog-details/dog-details-add.svg'}
                alt="Add"
                className="h-4 w-4 mr-2"
              />
              Add another dog
            </button>
          )}
        </div>
      </div>
    )
  }

  const renderBundles = () => {
    return (
      <div
        className={`${turboRouteConfiguration.plans.length > 3 ? 'grid grid-cols-2 lg:grid-cols-4' : 'flex flex-row '} gap-x-2 xs:gap-x-4 md:gap-x-8 lg:gap-x-16 w-full justify-center items-center mx-auto 2xl:max-w-[75%] items-stretch`}
      >
        {turboRouteConfiguration.plans.map((plan: any, index: number) => (
          <div
            key={index}
            className={`fade-fussy-show mb-4 flex flex-col flex-1 md:flex-none md:mb-0 w-auto mx-1 lg:mx-0`}
            style={{ animationDelay: `${index * 200}ms` }}
          >
            <button
              className={`bg-white flex flex-col sm:flex-row lg:flex-col items-center justify-center rounded-3xl sm:px-2 md:px-8 lg:px-12 hover:bg-[#B0CDD5] focus:bg-[#B0CDD5] border-2 border-[#006685] py-2 lg:py-0 lg:min-h-[100px] transition-all duration-300 hover:scale-105 h-full
  ${selectedPack?.name === plan.name ? 'bg-[#B0CDD5] border-4 scale-110 lg:min-h-[120px] lg:px-10 md:px-8 sm:px-6' : ''}`}
              type="button"
              onClick={() => {
                triggerTagging('turbo_route_bundle_selected', 'turbo_route', parseInt(plan.ongoing.size))
                setPackSize(parseInt(plan.ongoing.size))
                setSelectedPack(plan)
                if (dogNames.every(name => name.trim() === '')) {
                  setErrors(dogNames.map(name => (name.trim() === '' ? "Please enter your dog's name." : '')))
                  return
                }
              }}
            >
              {plan.planImage && (
                <CdnImage
                  className="block h-12 w-12 object-contain center items-center lg:h-24 aspect-auto lg:w-24 pr-1 lg:pr-0"
                  url={plan.planImage}
                  alt={plan.planImageAlt}
                />
              )}

              <div className="flex flex-col justify-end lg:justify-center items-center sm:items-start lg:items-center text-left sm:text-center lg:pb-4">
                <span className="lg:px-2 lg:p-2 font-sans font-bold text-sm lg:text-base">{plan.name}</span>
                {plan.description && <div dangerouslySetInnerHTML={{ __html: plan.description }} />}
                {turboRouteConfiguration.displayPackInformation && (
                  <div className="flex flex-row justify-start sm:justify-center">
                    {!turboRouteConfiguration.flexibleQuantity && <p className="pr-1">{plan.ongoing.quantity} x </p>}
                    <p>
                      {plan.ongoing.size}g every {plan.ongoing.weeks} weeks
                    </p>
                  </div>
                )}
              </div>
            </button>
          </div>
        ))}
      </div>
    )
  }

  const renderInfoSection = () => {
    return (
      <div className="relative fade-in flex flex-row justify-start items-center mx-auto w-full md:w-11/12 md:max-w-[46rem] bg-white p-4 my-6 rounded-3xl">
        <div className="absolute top-2 right-0 sm:right-4 px-3 py-1 text-base">
          {turboRouteConfiguration.showPricePerDay && pricePerDay ? (
            <p className={`${pricePerDay ? 'fade-in' : ''}`}>
              From <span className="font-bold text-lg">£{getDiscountedPrice(pricePerDay).toFixed(2)}</span>&nbsp;per day
            </p>
          ) : (
            <>
              {selectedPack?.ongoing?.price && (
                <>
                  <span className="font-semibold text-sm text-[#5F6977] strikethrough-grey !border-ddGrey">
                    &pound;{(selectedPack?.ongoing?.price / 100)?.toFixed(2)}
                  </span>
                  <span className="font-bold text-lg ml-2">
                    £{(getDiscountedPrice(selectedPack?.ongoing?.price) / 100).toFixed(2)}
                  </span>
                </>
              )}
            </>
          )}
        </div>
        <div className="flex flex-col items-start">
          <p className="font-sans font-bold text-left pb-2">You will receive:</p>
          <div className="flex items-start gap-2 w-full my-1">
            <img className="w-6 h-6 object-contain" src={Discount} alt="Discount" />
            <p className="text-sm flex-1 text-left">
              {lastValidatedCoupon && isValidCoupon ? (
                <>
                  <p className="text-sm flex-1 text-left">
                    <span className="font-bold">
                      {lastValidatedCoupons[0]?.type === 'percentage'
                        ? `${lastValidatedCoupons[0]?.amount}% off`
                        : `£${(lastValidatedCoupons[0]?.amount / 100).toFixed(2)} off`}
                    </span>{' '}
                    {lastValidatedCoupons[0]?.uses > 1
                      ? `your first ${lastValidatedCoupons[0]?.uses} boxes!`
                      : 'your Taster Box,'}
                    {lastValidatedCoupons.length > 1 && (
                      <>
                        {' '}
                        <span className="font-bold">
                          {lastValidatedCoupons[1]?.type === 'percentage'
                            ? lastValidatedCoupons[1]?.amount + '% off'
                            : '£' + (lastValidatedCoupons[1]?.amount / 100).toFixed(2)}{' '}
                        </span>{' '}
                        {lastValidatedCoupons[1]?.uses > 1
                          ? `your next ${lastValidatedCoupons[1]?.uses} orders`
                          : 'your first order'}
                      </>
                    )}
                  </p>
                </>
              ) : (
                <>
                  <span className="font-bold">30% off</span> your Taster Box,
                </>
              )}
            </p>
          </div>
          <div className="flex items-start gap-2 w-full my-1">
            <img className="w-6 h-6 object-contain" src={Pack} alt="Pack" />

            {!selectedPack?.trial?.quantity ? (
              <p className="text-sm flex-1 text-left">
                <span className="font-bold">
                  {selectedPack?.ongoing?.quantity} x {selectedPack?.ongoing?.size}g packs
                </span>{' '}
                of freshly cooked food
                <span className="font-bold"> every {selectedPack?.ongoing?.weeks} weeks</span>
              </p>
            ) : (
              <p className="text-sm flex-1 text-left">
                <span className="font-bold">
                  {selectedPack?.trial?.quantity} x {selectedPack?.trial?.size}g packs
                </span>{' '}
                in your Taster Box,
                <br />
                <span className="font-bold">
                  {selectedPack?.ongoing?.quantity} x {selectedPack?.ongoing?.size}g packs
                </span>{' '}
                ongoing, delivered
                <span className="font-bold"> every {selectedPack?.ongoing?.weeks} weeks</span>
              </p>
            )}
          </div>
          <div className="flex items-start gap-2 w-full my-1">
            <img className="w-6 h-6 object-contain" src={Treat} alt="Treat" />
            <p className="text-sm flex-1 text-left">
              1 x <span className="font-bold">FREE treat</span> in your Taster Box
            </p>
          </div>
          {showFreeSample && (
            <div className="flex items-start gap-2 w-full my-1">
              <img className="w-6 h-6 object-contain" src={Sample} alt="Sample" />
              <p className="text-sm flex-1 text-left">
                1 x <span className="font-bold">FREE Goats Milk</span> sample to aid a smooth transition from your dog’s
                current food
              </p>
            </div>
          )}

          <div className="flex items-start gap-2 w-full my-1">
            <img className="w-6 h-6 object-contain" src={Vet} alt="Vet" />
            <p className="text-sm flex-1 text-left">FREE consultations with our vet &amp; nutritionist</p>
          </div>
        </div>
      </div>
    )
  }

  const renderRecipeCard = (recipe: any, selectedRecipe: any) => {
    return (
      <li
        onClick={() => {
          setModalShow(true)
          setModalActiveRecipe(recipe)
        }}
        className={`relative overflow-hidden rounded-[20px] lg:rounded-[30px] ${
          recipe.range === 'health' ? 'bg-[#D7EAD2]' : 'bg-[#F8F2EC]'
        } ${selectedRecipe && 'shadow-[0_0_0_4px_rgba(0,102,133,1)]'}`}
        key={recipe.itemId}
      >
        <div className={`flex h-full flex-col justify-between text-center`}>
          <div className="flex h-full flex-col">
            <div className="block grid-cols-3 md:grid md:grid-cols-1">
              <div
                className={`aspect-h-1 relative mx-auto w-full overflow-hidden md:rounded-none ${
                  simpleRecipeCards ? 'h-[100px] sm:h-[150px] lg:h-[120px] xl:h-[120px]' : 'lg:h-[160px]'
                }`}
              >
                {simpleRecipeCards
                  ? recipe?.images?.tertiary && (
                      <CdnImage
                        url={recipe?.images?.tertiary}
                        alt={recipe.name}
                        steps={[550]}
                        className={`${simpleRecipeCards ? 'object-cover' : 'max-h-[100px] md:max-h-[150px] object-contain md:object-cover'} w-full scale-150 transform h-full md:scale-100 block bg-[#F6E9DB]`}
                      />
                    )
                  : recipe?.images?.noBackground && (
                      <CdnImage
                        url={recipe?.images?.noBackground}
                        alt={recipe.name}
                        steps={[550]}
                        className="max-h-[100px] md:max-h-[150px] w-full scale-150 transform object-contain md:object-cover lg:max-h-full md:scale-100 block bg-[#F6E9DB]"
                      />
                    )}

                {/* Info button (only for simple view) */}
                {simpleRecipeCards && (
                  <button
                    style={{ lineHeight: '1rem', right: '0.5rem' }}
                    className="absolute top-[6%] lg:top-[5%] mr-1 inline-flex h-5 w-5 items-center justify-center rounded-full bg-white text-center text-[0.65rem] text-primary md:h-6 md:w-6 md:text-[1rem] font-medium xl:inline-flex border-2 border-primary"
                    onClick={() => {
                      setModalShow(true)
                      setModalActiveRecipe(recipe)
                    }}
                  >
                    i
                  </button>
                )}

                {/* Most popular banner */}
                {simpleRecipeCards && popularRecipeIds?.includes(recipe.itemId) && (
                  <div className="absolute bottom-0 left-0 w-full text-center font-sans font-medium text-xs z-10">
                    <span className="bg-[#628F5B] text-white py-2 block whitespace-normal break-words w-full">
                      Most popular
                    </span>
                  </div>
                )}

                {/* Adult only banner */}
                {simpleRecipeCards && (recipe.adultOnly || recipe?.itemId === 'RECP-SSFS') && (
                  <div className="absolute bottom-0 left-0 w-full text-center font-sans font-medium text-xs z-10">
                    <span className="bg-ddGrey text-white py-2 block whitespace-normal break-words w-full">
                      {recipe.adultOnly
                        ? 'Not suitable for pregnant and lactating dogs'
                        : 'Not suitable as a sole diet for puppies. Unsuitable for pregnant or nursing dogs'}
                    </span>
                  </div>
                )}
              </div>

              <div className="col-span-2 flex h-auto flex-grow flex-col">
                {!simpleRecipeCards && (recipe.adultOnly || recipe?.itemId === 'RECP-SSFS') && (
                  <div className="flex w-full justify-center text-center font-sans font-medium text-sm">
                    <span className="bg-[#E79085] py-2 mb-1 md:mb-0 whitespace-normal break-words w-full">
                      {recipe.adultOnly
                        ? 'Not suitable for pregnant and lactating dogs'
                        : 'Not suitable as a sole diet for puppies. Unsuitable for pregnant or nursing dogs'}
                    </span>
                  </div>
                )}

                <div className="col-span-2 flex h-auto flex-grow flex-col py-4 px-1 xs:p-4">
                  <h4
                    className={`text-center font-sans font-semibold ${simpleRecipeCards ? 'text-sm md:text-xl' : 'md:text-xl'}`}
                  >
                    {recipe.name}
                  </h4>
                  {!simpleRecipeCards && (
                    <p className="mt-4 flex h-full flex-grow flex-col text-center text-xs text-black md:text-sm">
                      {recipe.shortDescription}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>

          {!simpleRecipeCards && (
            <button
              className="pb-2.5 text-xs text-black underline sm:text-sm"
              onClick={() => {
                setModalShow(true)
                setModalActiveRecipe(recipe)
              }}
            >
              Nutritional Information
            </button>
          )}

          {(getRecipePrice(recipe?.itemId) ?? 0) > 0 && (
            <div className="mx-auto flex flex-col items-center justify-center text-center">
              <p className="text-base md:text-xl font-bold text-primary">+£{getRecipePrice(recipe.itemId)}</p>
            </div>
          )}

          {/* Add/Remove controls */}
          <div className="flex items-center justify-center mb-4 px-4">
            {getRecipeQuantity(recipe.itemId) > 0 && (
              <>
                <button
                  type="button"
                  className={`btn-cta mr-2 flex h-10 w-10 items-center !px-0 !py-0 !text-4xl disabled:bg-[#D1D5DA]`}
                  onClick={(e: any) => {
                    e.stopPropagation()
                    handleRemoveRecipe(recipe.itemId)
                  }}
                >
                  <span className="mb-[6px]">-</span>
                </button>
                <Field
                  name="recipe"
                  type="text"
                  placeholder="0"
                  className="w-1/3 rounded-3xl border border-gray-300 py-3 px-4 text-center shadow-sm focus:border-primary focus:ring-primary"
                  value={getRecipeQuantity(recipe.itemId)}
                  inputMode="none"
                  onFocus={(e: any) => e.target.blur()}
                  onClick={(e: any) => {
                    e.stopPropagation()
                  }}
                />
                <button
                  type="button"
                  className={`btn-cta ml-2 flex h-10 w-10 items-center !px-0 !py-0 !text-4xl disabled:cursor-not-allowed disabled:bg-[#D1D5DA] disabled:grayscale disabled:filter`}
                  onClick={(e: any) => {
                    e.stopPropagation()
                    handleAddRecipe(recipe.itemId)
                  }}
                  disabled={maxRecipeLimit}
                >
                  +
                </button>
              </>
            )}
            {getRecipeQuantity(recipe.itemId) === 0 && (
              <div className="relative group w-full">
                {maxRecipeLimit && (
                  <div
                    role="tooltip"
                    aria-hidden={!maxRecipeLimit}
                    className="absolute bottom-full left-1/2 w-11/12 mx-auto -translate-x-1/2 bg-white rounded-xl px-3 py-2 opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition duration-200 pointer-events-none z-10 font-sans font-medium text-black text-xs sm:text-sm"
                  >
                    You’ve reached the maximum number of recipes. Remove selected recipes in order to select other ones.
                  </div>
                )}
                <button
                  type="button"
                  disabled={maxRecipeLimit}
                  className={`btn-cta !px-8 !text-base !text-white disabled:cursor-not-allowed disabled:bg-[#D1D5DA] w-5/6 mx-auto`}
                  onClick={(e: any) => {
                    e.stopPropagation()
                    handleAddRecipe(recipe.itemId)
                  }}
                >
                  Add
                </button>
              </div>
            )}
          </div>
        </div>
      </li>
    )
  }

  const renderRecipeSection = () => {
    return (
      <div className={`fade-in flex center mt-4 mb-6 rounded-3xl bg-white w-full md:w-11/12 md:max-w-[46rem]`}>
        <Formik
          initialValues={{ recipes: [] }}
          validationSchema={RecipesSchema}
          onSubmit={() => {
            dispatch(addRecipes(recipes, true))
          }}
          validateOnMount
        >
          {props => {
            return (
              <div className={`relative ${!showRecipes ? 'my-0' : 'my-4'}`}>
                <div className={`p-2 pt-3 lg:py-4 w-full mx-auto ${!showRecipes ? 'md:w-[46rem]' : 'lg:w-auto'}`}>
                  {turboRouteConfiguration.preSelectRecipes ? (
                    <p className="font-sans font-semibold text-base text-center px-2">
                      We've added our most-loved recipes to your <span className="font-bold">subscription</span>
                    </p>
                  ) : (
                    <>
                      <p className="font-sans font-semibold text-base text-center px-2">Choose your recipes</p>
                      <p
                        className={`font-sans font-medium text-base text-center px-2 w-11/12 lg:w-4/5 mx-auto pt-4 ${recipeCardsShow ? 'pb-6' : ''}`}
                      >
                        With a wide range of tasty hand-cooked recipes, including our Health+ range, we're sure there is
                        something to get your dog excited at meal times.
                      </p>
                    </>
                  )}
                  {!recipeCardsShow && (
                    <div
                      className={`flex items-center justify-center ${showRecipes ? 'pb-6 pt-3' : 'py-3'} px-2 lg:px-4`}
                    >
                      <div className={`${showRecipes ? 'hidden' : 'block'}`}>
                        <StaticImage
                          objectFit="contain"
                          className={`w-16 h-auto mr-1 lg:mr-4 ${showRecipes ? 'hidden' : 'block'}`}
                          src="../../../images/builder/recipes.png"
                          alt="Recipes"
                        />
                      </div>
                      <div
                        className="flex items-center gap-2 text-center"
                        onClick={() => {
                          setShowRecipes(!showRecipes)
                        }}
                      >
                        <p className="cursor-pointer text-base font-sans font-medium text-[#006685] hidden lg:block">
                          {showRecipes ? 'Close' : 'Click to customise'}
                        </p>
                        <p className="cursor-pointer text-base font-sans font-medium text-[#006685] block lg:hidden">
                          {showRecipes ? 'Close' : 'Tap to customise'}
                        </p>

                        <StaticImage
                          className={`cursor-pointer w-4 h-auto ${showRecipes ? 'rotate-180' : 'rotate-0'}`}
                          src={'../../../images/checkout/cheveronDown.svg'}
                          alt="Dropdown"
                        />
                      </div>
                    </div>
                  )}
                  <div
                    id="minQuantityRecipeError"
                    className={`w-full text-center ${showMinQuantityErrorMessage ? 'mb-2' : 'mb-6'} ${showRecipes ? 'block' : 'hidden'}`}
                  >
                    <p>
                      You have{' '}
                      <span className="rounded bg-[#F58C82] p-2 text-lg font-bold text-white">{recipeCount}</span> out
                      of{' '}
                      <span className="rounded bg-[#F58C82] p-2 text-lg font-bold text-white">
                        {selectedPack?.trial?.quantity || selectedPack?.ongoing?.quantity}
                      </span>{' '}
                      packs selected
                    </p>
                  </div>
                  {showMinQuantityErrorMessage && (
                    <div className="text-center text-sm mb-6 text-red-500">
                      You need a minimum of &nbsp;{selectedPack?.trial?.quantity || selectedPack?.ongoing?.quantity}
                      &nbsp; recipes.
                    </div>
                  )}

                  {showRecipes && (
                    <ul className="mx-auto grid w-full gap-y-6 gap-x-4 xs:gap-x-8 xs:p-4 pt-0 md:max-w-[90%] grid-cols-2 md:grid-cols-3">
                      {recipeList && (
                        <>
                          {/* Standard recipes */}
                          {recipeList
                            .filter(recipe => recipe.status !== 'OUTOFSTOCK' && recipe.range === 'standard')
                            .map((recipe, _key) => {
                              const selectedRecipe = recipes?.find(r => r.id === recipe.itemId)
                              return (
                                <React.Fragment key={`standard-${recipe.itemId}`}>
                                  {renderRecipeCard(recipe, selectedRecipe)}
                                </React.Fragment>
                              )
                            })}
                          {showHealthRecipeCard && (
                            <li className="relative md:col-span-2 flex h-full flex-col items-center justify-center rounded-3xl bg-[#D7EAD2] p-4 text-center">
                              <p className="font-sans font-medium text-base lg:text-lg">
                                Discover our Health+ range below.
                              </p>
                            </li>
                          )}

                          {/* Health recipes */}
                          {recipeList
                            .filter(recipe => recipe.status !== 'OUTOFSTOCK' && recipe.range === 'health')
                            .map((recipe, _key) => {
                              const selectedRecipe = recipes?.find(r => r.id === recipe.itemId)
                              return (
                                <React.Fragment key={`health-${recipe.itemId}`}>
                                  {renderRecipeCard(recipe, selectedRecipe)}
                                </React.Fragment>
                              )
                            })}
                          {showEndRecipeCard && (
                            <li className="relative flex h-full flex-col items-center justify-center rounded-3xl bg-[#F8F2EC] p-4 text-center">
                              <p className="font-sans font-medium text-base lg:text-lg">
                                All our recipes are nutritionally balanced by our expert canine nutritionist, Bianca.
                              </p>
                            </li>
                          )}
                        </>
                      )}
                    </ul>
                  )}
                </div>
                {!recipeCardsShow && (
                  <div
                    className={`flex justify-center items-center gap-2 text-center ${showRecipes ? 'block' : 'hidden'}`}
                    onClick={() => setShowRecipes(!showRecipes)}
                  >
                    <p className="text-base font-sans font-semibold text-[#006685]">Close</p>

                    <StaticImage
                      className={`w-4 h-auto ${showRecipes ? 'rotate-180' : 'rotate-0'}`}
                      src={'../../../images/checkout/cheveronDown.svg'}
                      alt="Dropdown"
                    />
                  </div>
                )}
              </div>
            )
          }}
        </Formik>
      </div>
    )
  }

  const renderTreatOptions = () => {
    return (
      <div className="relative fade-in flex flex-col justify-center items-center mx-auto w-full md:w-11/12 md:max-w-[46rem] bg-white p-4 my-6 rounded-3xl">
        {freeTreatHeading ? (
          <div className="" dangerouslySetInnerHTML={{ __html: freeTreatHeading }} />
        ) : (
          <p className="font-sans font-semibold text-lg text-center py-3 px-2">
            Select your <span className="font-bold">FREE treat</span>
          </p>
        )}
        {freeTreatSubHeading && <div className="pb-4" dangerouslySetInnerHTML={{ __html: freeTreatSubHeading }} />}
        <ul className="mx-auto grid w-full gap-y-6 gap-x-4 xs:gap-x-8 xs:p-4 pt-0 md:max-w-[90%] grid-cols-2 md:grid-cols-3">
          {freeTreatList &&
            freeTreatList
              .filter(addon => addon.status !== 'OUTOFSTOCK')
              .map(addon => {
                const isSelected = selectedTreatId === addon.itemId

                return (
                  <li
                    key={addon.itemId}
                    onClick={(e: any) => {
                      if (!showTreatCardButton) {
                        e.stopPropagation()
                        setSelectedTreatId(addon.itemId)
                      } else {
                        setModalShow(true)
                        setModalActiveRecipe(addon)
                      }
                    }}
                    className={`relative ${!showTreatCardButton ? 'cursor-pointer' : ''} rounded-[20px] lg:rounded-[30px] transition-all duration-300 transform
                    ${isSelected ? `${showTreatCardButton ? 'bg-[#F8F2EC] border-[#6BA2B3] border-4 scale-105' : 'bg-[#B0CDD5] border-[#006685] border-4 scale-110'}` : `${showTreatCardButton ? 'hover:scale-[1.02] bg-[#F8F2EC]' : 'border-2 border-[#006685] hover:scale-[1.02] bg-white'}`}
                    ${showTreatCardButton ? 'bg-[#F8F2EC]' : ''}`}
                  >
                    <div className="flex h-full flex-col justify-between text-center">
                      <div
                        className={`rounded-t-[18px] lg:rounded-t-[26px] aspect-w-1 aspect-h-1 relative mx-auto w-full overflow-hidden`}
                      >
                        {addon?.images?.tertiary && (
                          <CdnImage
                            url={addon.images.tertiary}
                            alt={addon.name}
                            steps={[550]}
                            className="w-full h-full object-cover rounded-t-[inherit] max-h-[100px] sm:max-h-[150px] md:max-h-[250px] scale-150 transform md:object-cover lg:max-h-full md:scale-100 block"
                          />
                        )}
                      </div>
                      {simpleRecipeCards && (
                        <button
                          style={{ lineHeight: '1rem', right: '0.5rem' }}
                          className="absolute top-[6%] lg:top-[5%] mr-1 inline-flex h-5 w-5 items-center justify-center rounded-full bg-white text-center text-[0.65rem] text-primary md:h-6 md:w-6 md:text-[1rem] font-medium xl:inline-flex border-2 border-primary"
                          onClick={() => {
                            setModalShow(true)
                            setModalActiveRecipe(addon)
                          }}
                        >
                          i
                        </button>
                      )}
                      <p className="mt-2 text-sm md:text-base font-semibold pt-1 pb-3 lg:px-2">{addon.name}</p>

                      <div className="flex-grow" />
                      {showTreatCardButton && (
                        <button
                          type="button"
                          className={`btn-cta px-4 sm:!px-8 !text-white !text-xs sm:!text-[1rem] !leading-[1.5rem] font-sans disabled:cursor-not-allowed mx-auto flex items-center justify-center mb-4 ${isSelected ? '!bg-[#6BA2B3]' : ''} w-5/6`}
                          onClick={(e: any) => {
                            e.stopPropagation()
                            setSelectedTreatId(addon.itemId)
                          }}
                        >
                          {isSelected ? 'Selected' : 'Select'}
                          {isSelected && (
                            <FontAwesomeIcon
                              icon={faCheck}
                              style={{ color: '#ffffff' }}
                              className="ml-2 w-3 h-3 lg:h-5 lg:w-5"
                              aria-hidden="true"
                            />
                          )}
                        </button>
                      )}
                    </div>

                    {isSelected && !showTreatCardButton && (
                      <img
                        src={CheckCircle}
                        alt="checked"
                        className="absolute bottom-0 left-1/2 translate-x-[-50%] translate-y-1/2 pop-in"
                      />
                    )}
                  </li>
                )
              })}

          <li className="relative md:hidden flex h-full flex-col items-center justify-center rounded-3xl bg-[#F8F2EC] p-4 text-center">
            <p className="font-sans font-medium text-base lg:text-lg">Say "yes" to high-quality, high-value rewards</p>
          </li>
        </ul>
      </div>
    )
  }

  const renderCTAButton = () => {
    return (
      <div className="flex flex-col center w-full">
        <button
          className={`flex w-11/12 items-center justify-center mx-auto rounded-full border border-transparent bg-[#006685] px-5 py-3 text-base font-medium text-white md:w-96 md:text-lg ${isSubmitting ? 'opacity-50' : ''}`}
          onClick={handleSubmitToCheckout}
        >
          {isSubmitting ? 'Calculating' : 'Try it risk free'}
          <FontAwesomeIcon icon={faChevronRight} className="h-4 w-4 ml-2" aria-hidden="true" />
        </button>
      </div>
    )
  }

  const renderButtonMessage = () => {
    return (
      <>
        <p className="font-sans text-sm font-medium text-center mt-1">
          Empty-bowl guarantee.{' '}
          <a href="/terms-and-conditions" className="hover:underline" target={'_blank'} rel="noreferrer">
            T&Cs apply*
          </a>
        </p>
        <p className="font-sans text-base font-medium text-center mt-6">
          If your dog has allergies, a medical condition, or you'd like&nbsp;
          <br className="hidden md:block" />a tailored recommendation, take our quiz{' '}
          <a href="/signup/dog-details" className=" underline cursor-pointer">
            here
          </a>
          .
        </p>
      </>
    )
  }

  return (
    <>
      {/* Desktop header */}
      <div
        className="relative w-full bg-cover bg-top bg-no-repeat h-32 hidden lg:block mt-16"
        style={{
          backgroundImage: topBanner ? `url(${topBanner})` : 'none'
        }}
      >
        {topImage && (
          <CdnImage
            className="absolute left-1/2 top-0 transform -translate-x-1/2 -translate-y-1/2 w-[26rem] z-20 hidden lg:block"
            url={topImage}
            alt={topImageAlt}
          />
        )}
      </div>
      {/* Mobile header */}
      {topImageMobile && <CdnImage className="w-full h-full block lg:hidden" url={topImageMobile} alt={topImageAlt} />}
      <div
        className="relative w-full bg-cover bg-top bg-no-repeat h-16 block lg:hidden my-[-2rem]"
        style={{
          backgroundImage: topBannerMobile ? `url(${topBannerMobile})` : 'none'
        }}
      />

      <main className="relative mx-auto flex h-full w-full flex-col z-10">
        <div
          className={`mx-auto h-full w-full flex flex-col justify-center items-center`}
          style={{ backgroundColor: backgroundColor }}
        >
          {renderText()}
          {!removeWidget && !showTrustpilotImage && <div className="w-full py-2 lg:-mt-2 mb-2">{getWidget()}</div>}
          {showTrustpilotImage && (
            <div className="w-1/2 py-2 lg:-mt-2 mb-2 justify-center mx-auto">
              {' '}
              <a href="https://uk.trustpilot.com/review/differentdog.com" target="_blank" rel="noreferrer noopener">
                <StaticImage
                  objectFit="contain"
                  className="w-full"
                  src="../../../images/trustpilot-shortened.svg"
                  alt="Trustpilot"
                />
              </a>
            </div>
          )}
          {renderDogNameField()}
          {turboRouteConfiguration.heading && (
            <div className="" dangerouslySetInnerHTML={{ __html: turboRouteConfiguration.heading }} />
          )}
          {turboRouteConfiguration.subHeading && (
            <div className="" dangerouslySetInnerHTML={{ __html: turboRouteConfiguration.subHeading }} />
          )}
          <div className="w-11/12 lg:w-auto 2xl:container">
            {renderBundles()}
            {packSize > 0 && turboRouteConfiguration.renderInfoSection && renderInfoSection()}
            {packSize > 0 && renderRecipeSection()}
            {packSize > 0 &&
              turboRouteConfiguration.showFreeTreatOptions &&
              freeTreatOptionIds.length > 0 &&
              renderTreatOptions()}
            {renderCTAButton()}
            {renderButtonMessage()}
          </div>
        </div>
      </main>
      {/* Desktop footer image */}
      <div
        className="relative w-full bg-cover bg-top bg-no-repeat h-24 mb:4 md:mb-4 -mt-2 md:-mt-4 hidden lg:block"
        style={{
          backgroundImage: footerImage ? `url(${footerImage})` : 'none'
        }}
      />
      {/* Mobile footer image */}
      <div
        className="relative w-full bg-cover bg-top bg-no-repeat h-24 mb:4 md:mb-4 -mt-2 md:-mt-4 block lg:hidden"
        style={{
          backgroundImage: footerImageMobile ? `url(${footerImageMobile})` : 'none'
        }}
      />
      {!showStickyFooter && (
        <div className="fixed bottom-0 inset-x-0 z-[50] h-20 bg-[#F8F2EC] bg-opacity-75 backdrop-blur-sm w-full lg:w-11/12 mx-auto lg:rounded-t-3xl shadow-[0_-5px_15px_rgba(0,0,0,0.25)] flex items-center justify-center">
          <div className="w-11/12 lg:w-1/2 flex justify-center">{renderCTAButton()}</div>
        </div>
      )}
      <RecipeOrTreatAlterModal show={modalShow} setShow={setModalShow} activeRecipe={modalActiveRecipe} />
    </>
  )
}

export default TurboRoute

Builder.registerComponent(TurboRoute, {
  name: 'TurboRoute',
  inputs: [
    {
      name: 'turboRouteConfiguration',
      type: 'object',
      defaultValue: {
        heading: '',
        subHeading: '',
        plans: [],
        displayPackInformation: false,
        coupon: '',
        flexibleQuantity: false,
        renderInfoSection: false
      },
      subFields: [
        {
          name: 'plans',
          type: 'array',
          defaultValue: [],
          subFields: [
            { name: 'name', type: 'string', defaultValue: '' },
            { name: 'description', type: 'richText', defaultValue: '' },
            {
              name: 'planImage',
              type: 'file',
              allowedFileTypes: ['jpeg', 'png', 'svg']
            },
            { name: 'planImageAlt', type: 'string', defaultValue: '' },
            {
              name: 'trial',
              friendlyName: 'Trial (Leave blank for ongoing)',
              type: 'object',
              defaultValue: {},
              subFields: [
                { name: 'size', type: 'string', enum: ['250', '600', '1000'], defaultValue: '' },
                {
                  name: 'weeks',
                  type: 'number',
                  enum: [
                    { label: '2 weeks', value: 2 },
                    { label: '4 weeks', value: 4 },
                    { label: '8 weeks', value: 8 }
                  ],
                  defaultValue: 0
                },
                { name: 'quantity', type: 'number', defaultValue: 0 },
                { name: 'price', type: 'number', defaultValue: 0 },
                { name: 'pricePerDay', type: 'number', defaultValue: 0 }
              ]
            },
            {
              name: 'ongoing',
              friendlyName: 'Ongoing (Default)',
              type: 'object',
              defaultValue: {},
              subFields: [
                { name: 'size', type: 'string', enum: ['250', '600', '1000'], defaultValue: '' },
                {
                  name: 'weeks',
                  type: 'number',
                  enum: [
                    { label: '2 weeks', value: 2 },
                    { label: '4 weeks', value: 4 },
                    { label: '8 weeks', value: 8 }
                  ],
                  defaultValue: 0
                },
                { name: 'quantity', type: 'number', defaultValue: 0 },
                { name: 'price', type: 'number', defaultValue: 0 },
                { name: 'pricePerDay', type: 'number', defaultValue: 0 }
              ]
            }
          ]
        },
        { name: 'heading', type: 'richText', defaultValue: '' },
        { name: 'subHeading', type: 'richText', defaultValue: '' },
        { name: 'displayPackInformation', type: 'boolean', defaultValue: false },
        { name: 'displayCalculatedPrice', type: 'boolean', defaultValue: false },
        { name: 'showPricePerDay', type: 'boolean', defaultValue: false },
        { name: 'showOriginalPriceStrikethrough', type: 'boolean', defaultValue: false },
        { name: 'coupon', type: 'string', defaultValue: '' },
        {
          name: 'defaultOffer',
          type: 'boolean',
          defaultValue: false
        },
        { name: 'flexibleQuantity', type: 'boolean', defaultValue: false },
        { name: 'preSelectRecipes', type: 'boolean', defaultValue: false },
        { name: 'renderInfoSection', type: 'boolean', defaultValue: false },
        { name: 'freeTreatId', type: 'string', defaultValue: '' },
        { name: 'showFreeTreatOptions', type: 'boolean', defaultValue: false }
      ]
    },
    {
      name: 'freeTreatOptionIds',
      type: 'list',
      subFields: [{ name: 'id', type: 'string' }],
      defaultValue: []
    },
    {
      name: 'freeTreatHeading',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'freeTreatSubHeading',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'simpleRecipeCards',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'recipeCardsShow',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'recipesWithMostPopularBanner',
      type: 'list',
      defaultValue: [
        {
          itemId: null
        }
      ],
      subFields: [{ name: 'itemId', type: 'text', defaultValue: '' }]
    },
    {
      name: 'showHealthRecipeCard',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'showEndRecipeCard',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'showTreatCardButton',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },

    {
      name: 'mainHeading',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'mainHeadingColor',
      type: 'color',
      defaultValue: '#006685'
    },
    {
      name: 'mainSubheading',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'textAlignment',
      type: 'string',
      enum: ['left', 'center', 'right'],
      defaultValue: 'center'
    },
    {
      name: 'topBanner',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'topBannerMobile',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'topImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'topImageMobile',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    { name: 'topImageAlt', type: 'string', defaultValue: '' },
    {
      name: 'footerImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'footerImageMobile',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'removeWidget',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'showTrustpilotImage',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'widgetType',
      type: 'string',
      enum: ['carousel', 'microCombo', 'list'],
      defaultValue: 'microCombo'
    },
    {
      name: 'widgetTags',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'widgetColor',
      type: 'color',
      defaultValue: '#004355'
    },
    {
      name: 'showFreeSample',
      type: 'boolean',
      defaultValue: false
    }
  ]
})
